module.exports = __webpack_public_path__ + "static/media/ominaispainomittari-kertoo-sokerin.589ee3bd.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/ominaispainomittari-kertoo-sokerin.mp4
 ** module id = 465
 ** module chunks = 0
 **/